<button (click)="addEvent.emit()" class="primary-btn" type="button">
  <mat-icon>add_circle</mat-icon>
  {{name}}
</button>
